import { DepositSliceState, Deposit, SmallDeposit } from 'src/core/models'
import { PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './state'

const reducers = {
  /* Deposits List Reducers */
  setDepositsListLoading: (state: DepositSliceState, action: PayloadAction<boolean>) => {
    state.list.loading = action.payload
  },
  setDepositsListError: (state: DepositSliceState, action: PayloadAction<any>) => {
    state.list.error = action.payload
  },
  setDepositsListData: (state: DepositSliceState, action: PayloadAction<Deposit[]>) => {
    state.list.deposits = action.payload
  },
  setSelectedDeposits: (state: DepositSliceState, action: PayloadAction<Deposit[]>) => {
    state.list.selectedDeposits = action.payload
  },
  setFilteredDeposits: (state: DepositSliceState, action: PayloadAction<Deposit[]>) => {
    state.list.filteredDeposits = action.payload
  },
  setDepositsFilterText: (state: DepositSliceState, action: PayloadAction<string>) => {
    state.list.filterText = action.payload
  },
  resetDepositsListState: (state: DepositSliceState) => {
    state.list = initialState.list
  },
  /* Remove Deposits Reducers */
  setRemoveDepositsLoading: (state: DepositSliceState, action: PayloadAction<boolean>) => {
    state.list.removeDeposits.loading = action.payload
  },
  setRemoveDepositsError: (state: DepositSliceState, action: PayloadAction<any>) => {
    state.list.removeDeposits.error = action.payload
  },
  setRemoveDepositsSuccess: (state: DepositSliceState, action: PayloadAction<boolean>) => {
    state.list.removeDeposits.success = action.payload
  },
  resetRemoveDepositsState: (state: DepositSliceState) => {
    state.list.removeDeposits = initialState.list.removeDeposits
  },
  /* Get Deposit Details Reducers */
  setFetchDepositsLoading: (state: DepositSliceState, action: PayloadAction<boolean>) => {
    state.fetchDeposit.loading = action.payload
  },
  setFetchDepositsError: (state: DepositSliceState, action: PayloadAction<any>) => {
    state.fetchDeposit.error = action.payload
  },
  setFetchDepositsData: (state: DepositSliceState, action: PayloadAction<SmallDeposit>) => {
    state.fetchDeposit.deposit = action.payload
  },
  resetFetchDepositsState: (state: DepositSliceState) => {
    state.fetchDeposit = initialState.fetchDeposit
  },
  /* Validate Deposits Reducers */
  setValidateDepositLoading: (state: DepositSliceState, action: PayloadAction<boolean>) => {
    state.validateDeposit.loading = action.payload
  },
  setValidateDepositSuccess: (state: DepositSliceState, action: PayloadAction<boolean>) => {
    state.validateDeposit.success = action.payload
  },
  setValidateDepositCurrentId: (state: DepositSliceState, action: PayloadAction<number>) => {
    state.validateDeposit.currentDepositId = action.payload
  },
  resetValidateDepositState: (state: DepositSliceState) => {
    state.validateDeposit = initialState.validateDeposit
  },
  /* Cancel Deposits Reducers */
  setCancelDepositLoading: (state: DepositSliceState, action: PayloadAction<boolean>) => {
    state.cancelDeposit.loading = action.payload
  },
  setCancelDepositSuccess: (state: DepositSliceState, action: PayloadAction<boolean>) => {
    state.cancelDeposit.success = action.payload
  },
  setCancelDepositCurrentId: (state: DepositSliceState, action: PayloadAction<number>) => {
    state.cancelDeposit.currentDepositId = action.payload
  },
  resetCancelDepositState: (state: DepositSliceState) => {
    state.cancelDeposit = initialState.cancelDeposit
  },
}

export default reducers
